module.exports = __webpack_public_path__ + "img/thanks.5125be13.svg";